<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="border bg-light p-3">
          Last Updated: <strong class="text-success">{{ ago }}</strong> ({{
            moment(lastFetched).format("h:mm:ss on ddd MMM Y")
          }})
        </div>
      </div>
    </div>

    <data-table
      :items="items"
      v-on:updateData="getOrders"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:headings>
        <div class="col-md-3">Customer</div>
        <div class="col-md-2">Status</div>
        <div class="col-md-1">Branch</div>
        <div class="col-md-2">Rapid#</div>
        <div class="col-md-2">Date</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-3 font-size-13 my-auto">
          <span class="text-primary font-weight-bold">{{
            slotProps.item.order_number
          }}</span>
          -
          {{ slotProps.item.customer.name }}
        </div>
        <div class="col-md-2 font-size-13 my-auto">
          <span
            class="font-weight-bold"
            :class="{
              'text-warning': slotProps.item.status == 'CAPTURED',
              'text-success': slotProps.item.status == 'PROCESSED',
              'text-info': slotProps.item.status == 'ATTENDING',
            }"
          >
            {{ slotProps.item.status }}
          </span>
        </div>
        <div class="col-md-1 font-size-13 my-auto">
          <span v-if="slotProps.item.branch">{{
            slotProps.item.branch.code
          }}</span>
        </div>
        <div class="col-md-2 font-size-13 my-auto">
          {{ slotProps.item.rapid_reference }}
        </div>
        <div class="col-md-2 font-size-13 my-auto">
          C:
          {{
            moment(new Date(slotProps.item.created_at)).format(
              "DD MMM YY, HH:mm"
            )
          }}
          <br />
          U:
          {{
            moment(new Date(slotProps.item.updated_at)).format(
              "DD MMM YY, HH:mm"
            )
          }}
        </div>

        <div class="col-md-2 text-right my-auto">
          <span
            v-if="
              slotProps.item.order_comments.filter((x) => x.clerk_read == 0)
                .length > 0
            "
            class="text-danger blink-me"
          >
            <i class="lni lni-comments font-size-19"></i>
          </span>

          <span
            class="text-info table-action-icon"
            @click="
              selectedOrder = slotProps.item;
              commentsRead(slotProps.item);
              setClerk(slotProps.item);
              orderDetailToggle = true;
            "
          >
            <i class="lni lni-search-alt"></i>
          </span>
        </div>
      </template>
    </data-table>

    <b-modal
      :hide-footer="true"
      title="Order Details"
      size="lg"
      v-model="orderDetailToggle"
      v-if="selectedOrder != null"
      @hidden="shouldUpdate ? changesNotSaved() : getData(true)"
    >
      <template #modal-header>
        <div class="row">
          <div class="col-auto">
            <span class="bg-primary text-white px-3 py-1">{{
              selectedOrder.order_number
            }}</span>
          </div>
          <div class="col">
            <h4 class="m-0">{{ selectedOrder.customer.name }}</h4>
            <small class="text-muted">{{
              selectedOrder.customer.trading_as
            }}</small>
          </div>
        </div>
        <button type="button" class="close" @click="orderDetailToggle = false">
          X
        </button>
      </template>

      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-md-6">
              <table class="table table-sm mt-2">
                <table-row label="Branch" :no-border="true"
                  >{{ selectedOrder.branch.name }}
                </table-row>
                <table-row
                  label="Code"
                  :no-border="true"
                  :copyText="selectedOrder.customer.rapid_code"
                  ><strong>{{ selectedOrder.customer.rapid_code }} </strong>
                </table-row>
                <table-row label="Status" :no-border="true">
                  <span
                    :class="{
                      'text-warning': selectedOrder.status == 'CAPTURED',
                      'text-success': selectedOrder.status == 'PROCESSED',
                      'text-info': selectedOrder.status == 'ATTENDING',
                    }"
                    ><strong>{{ selectedOrder.status }}</strong>
                  </span>
                </table-row>
                <table-row label="Created" :no-border="true"
                  >{{
                    moment(new Date(selectedOrder.created_at)).format(
                      "DD MMM YY, HH:mm"
                    )
                  }}
                  |
                  {{
                    moment(new Date(selectedOrder.updated_at)).format(
                      "DD MMM YY, HH:mm"
                    )
                  }}
                </table-row>
              </table>
            </div>
            <div class="col-md-6">
              <table class="table table-sm mt-2 border">
                <table-row label="Rep" :no-border="true"
                  >{{ selectedOrder.rep.name }}
                </table-row>
                <table-row
                  label="Cust. Ref"
                  :no-border="true"
                  :copyText="selectedOrder.customer_reference"
                  >{{ selectedOrder.customer_reference }}
                </table-row>
                <table-row
                  label="Rapid Ref"
                  :no-border="true"
                  :copyText="selectedOrder.rapid_reference"
                  >{{ selectedOrder.rapid_reference }}
                </table-row>
                <table-row label="Notes" :no-border="true">
                  <span class="text-danger font-weight-bold">
                    {{ selectedOrder.note }}
                  </span>
                </table-row>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="bg-light border p-3 my-2">
            <div class="row no-gutters">
              <div class="col-12">
                <small class="text-muted"
                  >Once an order is allocated a sales order reference it can not
                  be edited further.
                </small>
              </div>
              <div class="col-9">
                <input
                  class="form-control"
                  v-model="selectedOrder.rapid_reference"
                  placeholder="Rapid Reference"
                />
              </div>
              <div class="col-3">
                <button class="btn btn-success btn-block" @click="processOrder">
                  PROCESS
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead>
                <tr class="bg-dark text-white font-size-11 l-s-1">
                  <th>CODE</th>
                  <th>NAME</th>
                  <th class="text-center">ORDERED</th>
                  <th class="text-center">FULFILLED</th>
                  <th class="text-center">PRICE</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="product in selectedOrder.order_products"
                  :key="product.id"
                >
                  <td>
                    <strong
                      :class="{
                        'text-warning':
                          product.quantity_fulfilled < product.quantity_ordered,
                        'text-danger': product.quantity_fulfilled == 0,
                      }"
                      >{{ product.product.code }}</strong
                    >
                  </td>

                  <td>
                    {{ product.product.name }}
                  </td>

                  <td class="text-center">
                    {{ product.quantity_ordered }}
                  </td>

                  <td
                    class="text-center"
                    v-if="
                      selectedOrder.status == 'CAPTURED' ||
                      selectedOrder.status == 'ATTENDING'
                    "
                  >
                    <input
                      @change="shouldUpdate = true"
                      style="height: 30px; max-width: 90px"
                      v-model="product.quantity_fulfilled"
                      type="number"
                      step="1"
                      min="0"
                      class="form-control mx-auto m-0"
                    />
                  </td>

                  <td
                    class="text-center"
                    v-if="selectedOrder.status == 'PROCESSED'"
                  >
                    {{ product.quantity_fulfilled }}
                  </td>

                  <td class="text-center">
                    <strong
                      :class="{
                        'text-danger':
                          product.price < product.mandate_pricing_min,
                        'text-success':
                          product.price >= product.mandate_pricing_min,
                      }"
                      >{{ product.price | currency }}</strong
                    >
                  </td>
                  <td>
                    <i
                      class="lni lni-trash text-danger pointer"
                      @click="deleteLine(product)"
                      v-if="
                        product.is_clerk_entry == 1 &&
                        (selectedOrder.status == 'CAPTURED' ||
                          selectedOrder.status == 'ATTENDING')
                      "
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row my-2">
        <div class="col">
          <button class="btn btn-info btn-xs" @click="copyOrder">COPY</button>

          <button
            v-if="
              selectedOrder.status == 'CAPTURED' ||
              selectedOrder.status == 'ATTENDING'
            "
            class="btn btn-success btn-xs mx-2 float-right"
            :class="{ 'blink-me': shouldUpdate }"
            :disabled="isUpdatingOrder"
            @click="updateOrder"
          >
            UPDATE
          </button>
          <button
            v-if="
              selectedOrder.status == 'CAPTURED' ||
              selectedOrder.status == 'ATTENDING'
            "
            class="btn btn-primary btn-xs float-right"
            @click="addProductModalShow = true"
          >
            <i class="lni lni-circle-plus m-0"></i>
          </button>
        </div>
      </div>

      <div class="row my-5">
        <div class="col-12">
          <div class="border">
            <div v-if="loading">
              <b-spinner
                variant="primary"
                style="width: 3rem; height: 3rem"
                label="Large Spinner"
              ></b-spinner>
            </div>

            <div
              v-for="comment in selectedOrder.order_comments"
              :key="comment.id"
              class="card border-bottom p-2 mb-1"
            >
              <p class="nl2br">
                {{ comment.comment }}
              </p>

              <a v-if="comment.file_url" :href="comment.file_url" target="new">
                {{ comment.file_description }}<br />
              </a>

              <img
                v-if="comment.image"
                :src="comment.image"
                class="img-fluid maxWidth300 my-2"
              />

              <div class="row">
                <div class="col-auto">
                  <b-avatar v-if="!comment.user.image"></b-avatar>
                  <b-avatar
                    v-if="comment.user.image"
                    :src="comment.user.image"
                  ></b-avatar>
                </div>
                <div class="col">
                  <h6 class="mb-0 mt-1 font-weight-bold">
                    {{ comment.user.name }}
                  </h6>
                  <small class="text-muted">
                    <i class="lni lni-calendar"></i>
                    {{
                      moment(new Date(comment.created_at)).format(
                        "DD MMM YYYY, HH:mm:ss"
                      )
                    }}

                    |

                    {{
                      moment
                        .duration(
                          moment(Date.now()).diff(
                            moment(new Date(comment.created_at)),
                            "seconds"
                          ),
                          "seconds"
                        )
                        .format("Y [year] D [day], H [hour &] m [min]")
                    }}
                    ago
                  </small>
                </div>
              </div>
            </div>

            <form-base
              :submit-status="submitStatus"
              action="Comment"
              :errors="errors"
              :loading="loading"
              v-on:handleSubmit="createComment"
            >
              <template v-slot:fields>
                <form-group label="Comment" :required="true">
                  <textarea-autosize
                    class="form-control"
                    v-model="newComment.comment"
                  />
                </form-group>

                <form-group label="Attachments">
                  <p v-if="newComment.file_id != null" class="text-success">
                    File Loaded <i class="lni lni-checkmark"></i>
                  </p>
                  <p v-if="newComment.image_id != null" class="text-success">
                    Image Loaded <i class="lni lni-checkmark"></i>
                  </p>
                  <b-button v-b-toggle.collapse-1 variant="secondary" size="sm"
                    >Attach image or file</b-button
                  >
                  <b-collapse id="collapse-1" class="mt-2">
                    <b-card>
                      <form-group label="Image" v-if="!fileUploading">
                        <image-upload
                          :key="imageKey"
                          @files-uploaded="
                            newComment.image_id = $event;
                            imageUploading = false;
                          "
                          @files-uploaded-started="imageUploading = true"
                          :multiple="false"
                          :imageCrop="false"
                          :validationState="imageVstate"
                          acceptedTypes="image/*"
                        ></image-upload>
                      </form-group>

                      <form-group label="File" v-if="!imageUploading">
                        <file-upload
                          :key="fileComponentKey"
                          @files-uploaded="
                            newComment.file_id = $event;
                            fileUploading = false;
                          "
                          @files-uploaded-started="fileUploading = true"
                          :multiple="false"
                        />
                        <small class="text-muted font-size-11"
                          >*Max file size is 16MB</small
                        >
                      </form-group>
                    </b-card>
                  </b-collapse>
                </form-group>
              </template>
            </form-base>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Product selection modal -->
    <b-modal
      @shown="focusGroupSearch"
      :title="selectedGroup == null ? 'Group Selection' : selectedGroup.name"
      :hide-footer="true"
      size="lg"
      v-model="addProductModalShow"
      @hidden="selectedGroup = null"
    >
      <!-- group select -->
      <div v-show="selectedGroup == null">
        <div class="row">
          <div class="col-12">
            <input
              ref="groupordersearch"
              v-model="groupSearchText"
              type="text"
              class="form-control"
              style="max-width: 200px"
              placeholder="search groups"
              @keyup="filterGroups($event)"
            />
          </div>
        </div>

        <div
          class="col text-muted my-3"
          v-if="productGroups.filter((x) => !x.hidden).length == 0"
        >
          No Groups found
          <span v-if="groupSearchText && groupSearchText.length > 0"
            >matching {{ groupSearchText }}</span
          >
        </div>

        <div class="row" :key="groupKey">
          <div
            class="col-6 col-sm-4 col-lg-3 mt-3"
            v-for="group in productGroups.filter((x) => !x.hidden)"
            :key="group.id"
          >
            <div
              class="card border is-link-card text-center"
              :style="
                'height: 90px;background-size:cover;background-position:center;background-image:url(' +
                group.image +
                ');'
              "
              @click="selectedGroup = group"
            >
              <strong class="bg-dark text-white p-1 my-auto mx-auto">{{
                group.name
              }}</strong>
            </div>
          </div>
        </div>
      </div>

      <!-- product select -->
      <div v-if="selectedGroup != null">
        <div class="row">
          <div class="col-12">
            <input
              ref="productordersearch"
              type="text"
              class="form-control float-left"
              style="max-width: 200px"
              placeholder="search products"
              @keyup="filterProducts($event)"
            />
            <button
              class="btn btn-primary btn-sm float-right"
              @click="selectedGroup = null"
            >
              <i class="lni lni-arrow-left-circle m-0"></i>
            </button>
          </div>
        </div>
        <div class="row" :key="productKey">
          <div
            class="col text-muted my-3"
            v-if="
              products.filter(
                (x) => !x.hidden && x.product_group_id == selectedGroup.id
              ).length == 0
            "
          >
            No Products found
          </div>

          <div class="col">
            <div
              v-for="product in products.filter(
                (x) => !x.hidden && x.product_group_id == selectedGroup.id
              )"
              :key="product.id"
              class="card border is-link-card mt-1"
              :class="{ 'bg-light-green': product.on_promotion == 1 }"
              @click="selectProduct(product)"
            >
              <div class="card-body px-1 py-1">
                <div class="row no-gutters">
                  <div class="col-3">
                    <span
                      class="font-weight-bold font-size-11 my-auto"
                      :class="{
                        'text-success blink-me': product.on_promotion == 1,
                      }"
                      >{{ product.code }}</span
                    >
                  </div>
                  <div class="col-6 l-h-1">
                    <span class="font-weight-bold font-size-11">{{
                      product.name
                    }}</span>
                    <br />
                    <small class="text-muted font-size-11">{{
                      product.brand.name
                    }}</small>
                  </div>
                  <div class="col-3 text-right font-weight-bold font-size-11">
                    {{ product.mandate_pricing_min | currency }}
                    <br />
                    <small class="text-muted font-size-11"
                      >{{ product.mandate_pricing_max | currency }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Product Add modal -->
    <b-modal
      size="lg"
      :title="selectedProduct != null ? selectedProduct.name : ''"
      :hide-footer="true"
      v-model="productSelectedModalShow"
      @hidden="
        selectedProduct = null;
        selectedGroup = null;
        selectedPrice = null;
        selectedQuantity = null;
      "

    >
      <div class="row" v-show="selectedProduct != null" :key="productImageKey">
        <div class="col">
          <form @submit.prevent="addProduct()">
            <div class="row" v-if="selectedProduct != null">
              <div class="col">
                <div class="border w-50 p-2 float-left">
                  <small class="text-muted">MIN (Mandate)</small>
                  <h6 class="font-weight-bold text-primary">
                    {{ selectedProduct.mandate_pricing_min | currency }}
                  </h6>
                </div>
                <div
                  class="border w-50 p-2 float-left"
                  v-show="selectedProduct.mandate_pricing_max != null"
                >
                  <small class="text-muted">MAX (List Price)</small>
                  <h6 class="font-weight-bold text-danger">
                    {{ selectedProduct.mandate_pricing_max | currency }}
                  </h6>
                </div>
              </div>
            </div>

            <div class="border bg-light p-2 mb-2">
              <div class="row no-gutters">
                <div class="col-6 pr-1">
                  <small class="font-size-9 text-muted font-weight-bold"
                    >QUANTITY</small
                  >
                  <input
                    ref="productquanity"
                    inputmode="decimal"
                    min="0"
                    lang="en"
                    step="0.01"
                    class="form-control"
                    v-model="selectedQuantity"
                  />

                  <div></div>

                  <div
                    class="btn-group-vertical bg-white border mt-2"
                    role="group"
                    style="padding: 2px"
                  >
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="selectedQuantity += 10"
                      ><i class="lni lni-plus m-0"></i
                    ></span>
                    <span class="btn btn-link btn-sm font-size-11">10</span>
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="selectedQuantity -= 10"
                      ><i class="lni lni-minus m-0"></i
                    ></span>
                  </div>

                  <div
                    class="btn-group-vertical bg-white border mt-2"
                    role="group"
                    style="padding: 2px"
                  >
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="selectedQuantity += 50"
                      ><i class="lni lni-plus m-0"></i
                    ></span>
                    <span class="btn btn-link btn-sm font-size-11">50</span>
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="selectedQuantity -= 50"
                      ><i class="lni lni-minus m-0"></i
                    ></span>
                  </div>

                  <div
                    v-if="
                      selectedProduct != null &&
                      selectedProduct.cases_per_pallet == null
                    "
                    class="btn-group-vertical bg-white border mt-2"
                    role="group"
                    style="padding: 2px"
                  >
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="selectedQuantity += 100"
                      ><i class="lni lni-plus m-0"></i
                    ></span>
                    <span class="btn btn-link btn-sm font-size-11">100</span>
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="selectedQuantity -= 100"
                      ><i class="lni lni-minus m-0"></i
                    ></span>
                  </div>

                  <div
                    v-if="
                      selectedProduct != null &&
                      selectedProduct.cases_per_pallet != null
                    "
                    class="btn-group-vertical bg-white border mt-2"
                    role="group"
                    style="padding: 2px"
                  >
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="
                        selectedQuantity += selectedProduct.cases_per_pallet
                      "
                      ><i class="lni lni-plus m-0"></i
                    ></span>
                    <span class="btn btn-link btn-sm font-size-11">PAL</span>
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="
                        selectedQuantity -= selectedProduct.cases_per_pallet
                      "
                      ><i class="lni lni-minus m-0"></i
                    ></span>
                  </div>
                </div>
                <div class="col-6">
                  <small class="font-size-9 text-muted font-weight-bold"
                    >PRICE</small
                  >
                  <b-form-spinbutton
                    locale="en"
                    v-model="selectedPrice"
                    step="0.01"
                    min="0"
                    max="1000000"
                  ></b-form-spinbutton>

                  <div></div>

                  <div
                    class="btn-group-vertical bg-white border float-right mt-2"
                    role="group"
                    style="padding: 2px"
                  >
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="selectedPrice += 1.0"
                      ><i class="lni lni-plus m-0"></i
                    ></span>
                    <span class="btn btn-link btn-sm font-size-11">R1</span>
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="selectedPrice -= 1.0"
                      ><i class="lni lni-minus m-0"></i
                    ></span>
                  </div>

                  <div
                    class="btn-group-vertical bg-white border float-right mt-2"
                    role="group"
                    style="padding: 2px"
                  >
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="selectedPrice += 0.5"
                      ><i class="lni lni-plus m-0"></i
                    ></span>
                    <span class="btn btn-link btn-sm font-size-11">50c</span>
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="selectedPrice -= 0.5"
                      ><i class="lni lni-minus m-0"></i
                    ></span>
                  </div>

                  <div
                    class="btn-group-vertical bg-white border float-right mt-2"
                    role="group"
                    style="padding: 2px"
                  >
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="selectedPrice += 0.05"
                      ><i class="lni lni-plus m-0"></i
                    ></span>
                    <span class="btn btn-link btn-sm font-size-11">5c</span>
                    <span
                      class="btn btn-light btn-sm font-size-11"
                      @click="selectedPrice -= 0.05"
                      ><i class="lni lni-minus m-0"></i
                    ></span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <button
                    class="btn btn-success btn-sm btn-block mt-3"
                    type="submit"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div class="row border-top pt-2" v-if="selectedProduct != null">
            <div class="col-8">
              <p class="m-0 font-weight-bold">{{ selectedProduct.code }}</p>
              <h5 class="mt-0 mb-3">{{ selectedProduct.name }}</h5>
            </div>
            <div class="col-4 text-center text-md-right">
              <img
                v-if="selectedProduct != null && selectedProduct.image"
                :src="selectedProduct.image"
                class="img-fluid maxHeight200"
              />
            </div>
          </div>

          <table class="table table-sm mt-2" v-if="selectedProduct != null">
            <table-row :no-border="true" label="Description">{{
              selectedProduct.description
            }}</table-row>

            <table-row label="Cases Per Pallet"
              >{{ selectedProduct.cases_per_pallet }}
            </table-row>

            <table-row label="Supplier"
              >{{ selectedProduct.supplier.name }}
            </table-row>
            <table-row label="Brand"
              >{{ selectedProduct.brand.name }}
            </table-row>
          </table>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import customerBranchPricing from "@/mixins/customerBranchPricing";
import orderRepo from "@/api/repos/orderRepo";
import dataTable from "@/components/common/DataTable";
import tableRow from "@/components/common/TableRow";
import moment from "moment";
import ding from "./../../../assets/sounds/ding.wav";
import Push from "push.js";
import icon from "./../../../assets/img/logo.png";
import formGroup from "@/components/common/FormGroup";
import formBase from "@/components/common/FormBase";
import imageUpload from "@/components/common/ImageUpload";
import fileUpload from "@/components/common/FileUpload";

export default {
  mixins: [customerBranchPricing],
  components: {
    dataTable: dataTable,
    tableRow: tableRow,
    formBase,
    formGroup,
    imageUpload,
    fileUpload,
  },

  computed: {
    pricingBranchId() {
      return this.selectedOrder ? this.selectedOrder.branch_id : null;
    },
    imageVstate() {
      return null;
    },
  },

  data() {
    return {
      timer: null,
      timer2: null,
      lastFetched: null,
      ago: null,
      selectedOrder: null,
      orderDetailToggle: false,
      isLoad: false,
      sort: { column: "status", label: "Status Asc", order: "asc" },
      sort2: { column: "created_at", label: "Created Desc", order: "desc" },
      sortOptions: [],
      filterOptions: [],
      filters:[],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
      shouldUpdate: false,
      isUpdatingOrder: false,
      productGroups: [],
      suppliers: [],
      brands: [],
      selectedBranch: null,
      selectedGroup: null,
      selectedCustomer: null,
      groupKey: 1,
      productKey: 1,
      productImageKey: 1,
      addProductModalShow: false,
      productSelectedModalShow: false,
      selectedProduct: null,
      selectedPrice: null,
      selectedQuantity: null,
      groupSearchText: null,
      newComment: { image_id: null, comment: null, commenter: "CLERK" },
      submitStatus: null,
      errors: null,
      loading: false,
      imageUploading: false,
      imageKey: 1,
      fileComponentKey: 1,
      fileUploading: false,
    };
  },
  mounted() {
    this.getData(false);
    this.getUpdateData();
    this.timer = setInterval(this.getData, 120000, true);
    this.timer2 = setInterval(this.updateLastFetched, 5000, true);
  },
  methods: {
    updateLastFetched() {
      this.ago = moment(this.lastFetched).fromNow();
    },
    focusGroupSearch() {
      // this.$refs.groupordersearch.focus();
    },
    getData(updating) {
      this.getOrders(
        {
          sort: this.sort,
          sort2: this.sort2,
          filters: this.filters,
          page: this.page,
          rowsPerPage: localStorage.getItem("rowsPerPage")
            ? localStorage.getItem("rowsPerPage")
            : 12,
          search: "",
        },
        updating
      );
    },
    async getUpdateData() {
      try {
        let { data } = await orderRepo.updateGetData();
        this.baseProducts = data.products;
        this.productGroups = data.product_groups;
        this.suppliers = data.suppliers;
        this.brands = data.brands;

        this.productGroups.forEach((x) => (x.hidden = false));
        this.products.forEach((x) => (x.hidden = false));
      } catch (error) {
        console.log(error);
      }
    },
    async getOrders(e, updating = false) {
      if (!updating) {
        this.isLoad = true;
      }
      try {
        let { data } = await orderRepo.process(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.sort2 != null ? e.sort2.column : this.sort2.column,
          e.sort2 != null ? e.sort2.order : this.sort2.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.sort = e.sort
        this.filters = e.filters != null ? e.filters : null

        if (updating && data.orders.total > this.totalRows) {
          this.$bvToast.toast("New Order", {
            toaster: "b-toaster-top-full",
            title: "Orders",
            autoHideDelay: 3000,
            variant: "success",
          });

          Push.create("New Order!", {
            body: "New Order",
            icon: icon,
            timeout: 3000,
            onClick: function () {
              window.focus();
              this.close();
            },
          });

          var audioFile = new Audio(ding);
          audioFile.play();
        }

        data.orders.data = data.orders.data.map((x) => {
          return {
            ...x,
            danger:
              x.order_comments.filter((x) => x.clerk_read == 0).length > 0
                ? true
                : false,
          };
        });

        this.items = data.orders.data;
        this.totalRows = data.orders.total;
        this.page = data.orders.current_page;
        this.fromRow = data.orders.from;
        this.toRow = data.orders.to;
        this.lastPage = data.orders.last_page;

        this.filterOptions = [];

        this.filterOptions.push({
          column: "group-heading",
          label: "status",
        });

        this.filterOptions.push(
          {
            column: "status",
            value: "CAPTURED",
            label: "CAPTURED",
          },
          {
            column: "status",
            value: "ATTENDING",
            label: "ATTENDING",
          },
          {
            column: "status",
            value: "PROCESSED",
            label: "PROCESSED",
          }
        );

        this.filterOptions.push({
          column: "group-heading",
          label: "branches",
        });

        data.clerks.forEach((b) => {
          this.filterOptions.push({
            column: "branch_id",
            value: b.branch_id,
            label: b.branch.name,
          });
        });

        this.lastFetched = Date.now();
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    async processOrder() {
      if (this.selectedOrder.rapid_reference == null) {
        this.$bvToast.toast("Please enter reference", {
          title: "Error",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }

      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to process order?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (confirm) => {
          if (confirm) {
            try {
              await orderRepo.processUpdate(this.selectedOrder);

              this.$bvToast.toast("Order Updated", {
                title: "Success",
                autoHideDelay: 3000,
                variant: "success",
              });

              this.orderDetailToggle = false;
              this.getOrders({
                sort: this.sort,
                sort2: this.sort2,
                filters: null,
                page: this.page,
                rowsPerPage: localStorage.getItem("rowsPerPage")
                  ? localStorage.getItem("rowsPerPage")
                  : 12,
                search: "",
              });
            } catch (err) {
              this.$bvToast.toast("Something Went Wrong" + err.message, {
                title: "Error",
                autoHideDelay: 3000,
                variant: "danger",
              });
            }
          }
        })
        .catch((error) => console.log(error));
    },

    changesNotSaved() {
      this.$bvToast.toast(
        "The changes you made to the order were not updated.",
        {
          title: "Warning",
          autoHideDelay: 3000,
          variant: "warning",
        }
      );

      this.shouldUpdate = false;
      this.getData(true);
    },
    async updateOrder() {
      if (this.isUpdatingOrder) return;
      const order = this.selectedOrder;
      const lines = order.order_products.slice();
      const snapshot = JSON.stringify(lines);
      this.isUpdatingOrder = true;
      try {
        const { data } = await orderRepo.update({ ...order, order_products: JSON.parse(snapshot) });
        const hasNewEdits = JSON.stringify(order.order_products) !== snapshot;
        (data.order_products || []).forEach((saved, index) => {
          ['id', 'mandate_pricing_min', 'mandate_pricing_max', 'mandate_profit'].forEach(field => {
            this.$set(lines[index], field, saved[field]);
          });
        });
        if (this.selectedOrder === order) this.shouldUpdate = hasNewEdits;

        this.$bvToast.toast("Order Updated", {
          title: "Success",
          autoHideDelay: 3000,
          variant: "success",
        });
      } catch (err) {
        this.$bvToast.toast("Something Went Wrong" + err.message, {
          title: "Error",
          autoHideDelay: 3000,
          variant: "danger",
        });
      } finally {
        this.isUpdatingOrder = false;
      }
    },

    deleteLine(op) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the line", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => {
          if (confirm) {
            this.shouldUpdate = true;
            this.selectedOrder.order_products =
              this.selectedOrder.order_products.filter((x) => {
                if (x.is_clerk_entry == 1 && x.product_id == op.product_id) {
                  return false;
                }

                return true;
              });
          }
        })
        .catch((error) => console.log(error));
    },

    selectProduct(product) {
      this.selectedProduct = product;
      this.selectedPrice = parseFloat(product.mandate_pricing_min);
      this.productSelectedModalShow = true;
      this.productImageKey++;
    },

    addProduct() {
      if (
        this.selectedQuantity == null ||
        this.selectedPrice == null ||
        this.selectedProduct == null ||
        this.selectedQuantity <= 0 ||
        this.selectedPrice <= 0
      ) {
        this.$root.$bvToast.toast("Please fill in required fields", {
          title: "Errors on form data",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }

      this.selectedOrder.order_products.push({
        uid: Date.now(),
        product_id: this.selectedProduct.id,
        is_clerk_entry: 1,
        mandate_pricing_min: this.selectedProduct.mandate_pricing_min,
        mandate_pricing_max: this.selectedProduct.mandate_pricing_max,
        product: {
          code: this.selectedProduct.code,
          name: this.selectedProduct.name,
        },
        quantity_ordered: parseFloat(
          this.selectedQuantity.toString().replace(",", ".")
        ),
        quantity_fulfilled: parseFloat(
          this.selectedQuantity.toString().replace(",", ".")
        ),
        price: parseFloat(this.selectedPrice.toString().replace(",", ".")),
      });

      this.selectedProduct = null;
      this.selectedGroup = null;
      this.productSelectedModalShow = false;
      this.addProductModalShow = false;
      this.selectedPrice = null;
      this.selectedQuantity = null;
      this.groupSearchText = null;
      this.productGroups.forEach((x) => (x.hidden = false));

      this.shouldUpdate = true;

      this.$root.$bvToast.toast("Product Added", {
        title: "Success",
        autoHideDelay: 1000,
        variant: "success",
      });
    },

    copyOrder() {
      let text = "";

      this.selectedOrder.order_products.forEach((p) => {
        text +=
          p.product.code.trim() +
          "," +
          p.quantity_ordered +
          "," +
          p.price +
          "\n";
      });

      navigator.clipboard.writeText(text).then(
        () => {
          this.$bvToast.toast("Copied", {
            title: "Paste in rapid",
            autoHideDelay: 1200,
            variant: "success",
          });
        },
        (err) => {
          this.$bvToast.toast("Not Copied" + err, {
            title: "Error",
            autoHideDelay: 1200,
            variant: "error",
          });
        }
      );
    },

    async createComment() {
      this.loading = true;
      this.submitStatus = "PENDING";

      if (this.newComment == null) {
        this.$root.$bvToast.toast("Enter comment", {
          title: "Errors on form data",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.submitStatus = "ERROR";
        this.loading = false;
      } else if (this.imageUploading == true || this.fileUploading == true) {
        this.$root.$bvToast.toast("Wait for Image Upload", {
          title: "Errors on form",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.submitStatus = "ERROR";
        this.loading = false;
      } else {
        try {
          let { data } = await orderRepo.comment(
            this.selectedOrder,
            this.newComment
          );
          this.selectedOrder = data.order;
          this.newComment = {
            image_id: null,
            commenter: "CLERK",
            comment: null,
          };
          this.imageKey++;
          this.fileComponentKey++;
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          } else {
            this.$root.$bvToast.toast("Something Went Wrong", {
              title: error.response.data.message,
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },

    async commentsRead(id) {
      try {
        await orderRepo.commentsRead(id, "CLERK");
      } catch (e) {
        console.log(e);
      }
    },
    async setClerk(id) {
      try {
        await orderRepo.setClerk(id);
      } catch (e) {
        console.log(e);
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.timer) clearInterval(this.timer);
    if (this.timer2) clearInterval(this.timer2);
    next();
  },

  destroyed() {
    if (this.timer) clearInterval(this.timer);
    if (this.timer2) clearInterval(this.timer2);
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.orderDetailToggle = newVal.meta && newVal.meta.orderDetailToggle;
      },
    },
  },
};
</script>
